export default __webpack_public_path__ + "static/media/loader.ac5ca405.svg";